var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1773 2.88798L19.7972 28.0426C19.7182 28.2795 19.5693 28.4844 19.3716 28.628C19.1738 28.7716 18.9375 28.8466 18.6963 28.8422C18.4551 28.8379 18.2214 28.7544 18.0285 28.6037C17.8357 28.4531 17.6937 28.2429 17.6228 28.0034L14.2545 16.6289C14.1996 16.4436 14.1019 16.2751 13.97 16.138C13.8381 16.0009 13.6759 15.8994 13.4975 15.8424L2.55055 12.3426C2.31997 12.2689 2.11772 12.1213 1.97272 11.921C1.82772 11.7206 1.74738 11.4778 1.74319 11.2272C1.739 10.9766 1.81117 10.731 1.94939 10.5255C2.08761 10.3201 2.28479 10.1653 2.51277 10.0833L26.7221 1.37594C26.925 1.30297 27.1435 1.29079 27.3527 1.34079C27.5619 1.39079 27.7534 1.50096 27.9052 1.65869C28.057 1.81641 28.163 2.01534 28.2111 2.23273C28.2592 2.45012 28.2475 2.67719 28.1773 2.88798V2.88798Z",
    stroke: "white",
    strokeWidth: 2.2879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.20627377c2bb93bff6ae3ad56ecf9e14.svg";
export { ForwardRef as ReactComponent };